import Swiper, { Navigation, Pagination, EffectFade } from 'swiper';

document.addEventListener('readystatechange', () => {
    if (document.readyState !== 'complete') return;

    var isMobile = window.innerWidth <= 576;

    var swiper = new Swiper('.swiper-container', {
        autoHeight: isMobile, //enable auto height
        effect: 'fade',
        modules: [Navigation, Pagination, EffectFade],
        loop: true,
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true,
        },
        autoplay: isMobile
            ? false
            : {
                  delay: 8500,
                  disableOnInteraction: true,
              },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });
});
